import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent, HttpEventType, HttpHeaders, HttpResponse, HttpParams } from '@angular/common/http';
import { PerformanceParameter } from 'src/app/classes/entity/performace';
import { Observable } from 'rxjs';
import { PerformanceFeedProgram, PerformanceAdjustment, PerformanceGrowthADFI } from 'src/app/classes/entity/performace';
import { AbstractService } from './abstract.service';
//import { parseLazyRoute } from '@angular/compiler/src/aot/lazy_routes';
import { Base64 } from 'js-base64';
import { cloneDeep } from 'lodash';

@Injectable()
export class InputService extends AbstractService {

	constructor(http: HttpClient) {
		super(http);

	}

	getHttpOptions(): any {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
			}),
			'withCredentials': true
		};
		return httpOptions;
	}

	LoadPerfParamDetail(company): Observable<PerformanceParameter> {

		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
			}),
			'withCredentials': true
		};
		return this.http.get<PerformanceParameter>(this.apiPath + "getPerformanceParameter?accountId=" + company, httpOptions);
	}

	LoadPerformanceGrowthADFI(perfParmId): Observable<PerformanceGrowthADFI[]> {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
			}),
			'withCredentials': true
		};
		return this.http.get<PerformanceGrowthADFI[]>(this.apiPath + "GetPerformanceGrowthADFI?performanceParameterId=" + perfParmId, httpOptions);
	}

	LoadPerformanceFeedProgram(perfParmId): Observable<PerformanceFeedProgram[]> {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
			}),
			'withCredentials': true
		};
		return this.http.get<PerformanceFeedProgram[]>(this.apiPath + "GetPerformanceFeedProgram?performanceParameterId=" + perfParmId, httpOptions);
	}

	LoadPerformanceAdjustment(companyID, performanceParameterID): Observable<PerformanceAdjustment> {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
			}),
			'withCredentials': true
		};
		return this.http.get<PerformanceAdjustment>(this.apiPath + "getPerformanceAdjustment?accountId=" + companyID + "&performanceID=" + performanceParameterID, httpOptions);
	}

	savePerformanceParameter(payload) {
		var payloadCopy = cloneDeep(payload);
		payloadCopy.performanceParameter.performanceParameterName = Base64.encode(payloadCopy.performanceParameter.performanceParameterName);
		return this.http.post(this.apiPath + "savePerformanceParameter", payloadCopy, this.getHttpOptions());
	}
	savePerformanceAdjustment(payload) {
		var payloadCopy = cloneDeep(payload);
		payloadCopy.performanceParameter.performanceParameterName = Base64.encode(payloadCopy.performanceParameter.performanceParameterName);
		for (var i = 0; i < payloadCopy.listPerformanceAdjustment.length; i++) {
			payloadCopy.listPerformanceAdjustment[i].AdjustmentName = Base64.encode(payloadCopy.listPerformanceAdjustment[i].AdjustmentName);
		}
		return this.http.post(this.apiPath + "savePerformanceAdjustment", payloadCopy, this.getHttpOptions());
	}

	saveFeedProgram(payload) {
		var payloadCopy = cloneDeep(payload);
		payloadCopy.performanceParameter.performanceParameterName = Base64.encode(payloadCopy.performanceParameter.performanceParameterName);
		for (var i = 0; i < payloadCopy.listPerformanceFeedProgram.length; i++) {
			payloadCopy.listPerformanceFeedProgram[i].postWeaningFeedDiet = Base64.encode(payloadCopy.listPerformanceFeedProgram[i].postWeaningFeedDiet);
		}
		return this.http.post(this.apiPath + "saveFeedProgram", payloadCopy, this.getHttpOptions());
	}

	deletePerformanceParameter(accountID, performanceParameterID) {
		return this.http.post(this.apiPath + "deletePerformanceParameter?performanceParameterID=" + performanceParameterID, null, this.getHttpOptions());
	}

	updatePerformanceParameterStatus(parameterID) {

		return this.http.post(this.apiPath + "updatePerformanceParameterStatus?performanceParameterId=" + parameterID, null, this.getHttpOptions());
	}
}